module.exports = __webpack_public_path__ + "img/001.a38087c4.png";